import { IngredientsView } from './views/ingredients/IngredientsView'
export default IngredientsView
